import React, { useState } from "react";
import Spinner from "../common/Spinner";
import { formatDateInSpanish } from "../../helpers/general";
import BreadOrder from "./BreadOrder";
import Modal from "../common/Modal";
import styles from "./Bread.module.css";
// import breadService from '../../services/breadorders.service.ts';



export default function BreadTable({ breadOrders, loading }) {
    const [selectedOrder, setSelectedOrder] = useState(null);

    function handleRowClick(breadOrder) {
        setSelectedOrder(breadOrder);
    }

    function closeModal() {
        setSelectedOrder(null);
    }

    if (loading) {
        return <Spinner />;
    }

    // Group orders by date
    const ordersByDate = breadOrders.reduce((acc, order) => {
        if (!acc[order.date]) {
            acc[order.date] = [];
        }
        acc[order.date].push(order);
        return acc;
    }, {});

    return (
        <div className="">
            {/* <button onClick={() => breadService.addStoreIdToAllBreads()}> CLick me</button> */}
            {Object.keys(ordersByDate).map(date => (
                <div key={date} >
                    <h2>{formatDateInSpanish(date)} - Total de Pedidos: {ordersByDate[date].length}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Pan</th>
                                <th>Dia</th>
                                <th>Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ordersByDate[date].map(order => (
                                <tr key={order.id} onClick={() => handleRowClick(order)}>
                                    <td>{order.firstName} {order.lastName}</td>
                                    <td>{order.getBreads()}</td>
                                    <td>{order.date}</td>
                                    <td>{order.time}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
            {selectedOrder && (
                <Modal onClose={closeModal}>
                    <BreadOrder bread={selectedOrder} />
                </Modal>
            )}
        </div>
    );
}
